var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"selectIndex":2}},[_c('div',{staticStyle:{"text-align":"center","line-height":"58vh","font-size":"30px","font-weight":"bold"}},[_c('img',{attrs:{"src":require("@/assets/images/img/none.jpg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }